export const GrupoLogo = () => {
  return (
    <svg
      id="katman_2"
      data-name="katman 2"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 62.97 8.7"
    >
      <g id="Layer_1" data-name="Layer 1">
        <g>
          <path
            fillRule="evenodd"
            d="m60.33,1.98h.44c.21,0,.35-.03.43-.09.08-.06.11-.15.11-.25l-.06-.18-.15-.12c-.07-.03-.19-.04-.36-.04h-.41v.68Zm-.36,1.27V1h.77c.26,0,.45.02.57.06.12.04.21.12.28.22.07.1.1.22.1.33,0,.16-.06.31-.18.43-.12.12-.27.19-.46.21l.19.12c.09.09.2.24.33.45l.27.44h-.44l-.2-.35c-.16-.28-.28-.45-.38-.52-.07-.05-.16-.08-.29-.08h-.21v.96h-.36Zm.91-2.9c-.29,0-.58.08-.85.23-.28.15-.49.37-.65.65-.16.28-.24.57-.24.88s.08.59.23.87c.15.28.37.49.64.65.28.16.56.23.86.23s.59-.08.86-.23c.28-.15.49-.37.64-.65.15-.28.23-.57.23-.87s-.08-.6-.23-.88c-.16-.28-.37-.49-.65-.65-.28-.15-.56-.23-.85-.23m0-.35c.35,0,.69.09,1.02.27.33.18.59.44.78.77.19.34.28.68.28,1.05s-.09.71-.27,1.04c-.18.33-.44.59-.77.78-.33.18-.68.28-1.04.28s-.71-.09-1.04-.28c-.33-.18-.59-.44-.77-.78-.19-.33-.28-.68-.28-1.04s.09-.72.28-1.05c.19-.34.45-.59.78-.77.33-.18.67-.27,1.02-.27"
          />
          <path
            className="cls-2"
            d="m.14,7.38l.69.1c.03.21.11.36.24.45.18.13.42.19.72.19.33,0,.58-.07.76-.19.18-.13.3-.31.36-.54.04-.14.05-.44.05-.89-.31.36-.7.54-1.16.54-.57,0-1.02-.2-1.34-.61-.32-.41-.47-.89-.47-1.46,0-.39.07-.75.22-1.08.14-.33.35-.59.63-.77.27-.18.6-.27.97-.27.49,0,.9.2,1.22.59v-.49h.65v3.53c0,.64-.07,1.09-.2,1.35-.13.27-.34.48-.63.63-.29.16-.64.23-1.06.23-.5,0-.9-.11-1.21-.33-.31-.22-.46-.55-.45-.99m.59-2.46c0,.54.11.93.33,1.17.22.24.49.37.82.37s.6-.12.82-.37c.22-.24.33-.63.33-1.15s-.11-.88-.34-1.13c-.23-.26-.5-.38-.82-.38s-.58.13-.8.38c-.22.25-.33.62-.33,1.12"
          />
          <path
            className="cls-2"
            d="m4.75,7.04V2.95h.64v.62c.16-.29.31-.48.45-.57.14-.09.29-.14.45-.14.24,0,.48.07.73.22l-.24.64c-.18-.1-.35-.15-.52-.15-.16,0-.29.05-.42.14-.12.09-.21.22-.26.38-.08.25-.12.52-.12.81v2.14h-.71Z"
          />
          <path
            className="cls-2"
            d="m10.18,7.04v-.6c-.33.46-.77.69-1.33.69-.25,0-.48-.05-.69-.14-.21-.09-.37-.21-.48-.35-.1-.14-.18-.31-.22-.52-.03-.14-.04-.35-.04-.65v-2.53h.71v2.27c0,.36.01.61.04.73.04.18.14.32.28.43.15.1.32.16.54.16s.41-.05.6-.16c.18-.11.32-.25.39-.43.08-.18.12-.45.12-.8v-2.19h.71v4.09h-.63Z"
          />
          <path
            className="cls-2"
            d="m11.93,8.61V2.95h.65v.53c.15-.21.32-.36.51-.47.19-.1.42-.16.7-.16.36,0,.67.09.94.27.27.18.48.43.62.76.14.33.21.69.21,1.08,0,.42-.08.79-.23,1.13-.15.33-.38.59-.67.77-.29.18-.6.27-.92.27-.23,0-.45-.05-.64-.15-.19-.1-.34-.22-.46-.37v1.99h-.71Zm.64-3.59c0,.53.11.92.33,1.17.22.25.48.38.79.38s.59-.13.81-.39c.22-.26.34-.67.34-1.21s-.11-.91-.33-1.17c-.22-.26-.48-.39-.79-.39s-.57.14-.8.42c-.23.28-.35.68-.35,1.2"
          />
          <path
            className="cls-2"
            d="m16.15,4.99c0-.76.22-1.32.65-1.68.36-.3.8-.46,1.32-.46.57,0,1.04.18,1.41.55.37.37.55.88.55,1.53,0,.53-.08.94-.24,1.24-.16.3-.4.54-.7.7s-.65.25-1.01.25c-.59,0-1.06-.18-1.42-.55-.36-.37-.54-.9-.54-1.59m.73,0c0,.52.12.92.35,1.18.23.26.53.39.88.39s.65-.13.88-.39c.23-.26.35-.66.35-1.2,0-.51-.12-.89-.35-1.15-.24-.26-.53-.39-.88-.39s-.65.13-.88.39c-.23.26-.35.65-.35,1.18"
          />
          <rect className="cls-2" x="22.39" y="1.55" width="1.34" height="6.02" />
          <polygon
            className="cls-2"
            points="25.03 7.57 25.03 1.55 26.34 1.55 29.06 5.57 29.06 1.55 30.31 1.55 30.31 7.57 28.96 7.57 26.28 3.64 26.28 7.57 25.03 7.57"
          />
          <path
            className="cls-2"
            d="m31.73,1.55h2.46c.55,0,.98.04,1.27.11.39.1.72.29,1,.55.28.27.49.59.64.98.15.38.22.86.22,1.42,0,.49-.07.92-.2,1.28-.17.44-.4.79-.71,1.06-.23.21-.55.37-.94.48-.3.08-.69.13-1.19.13h-2.53V1.55Zm1.34,1.02v3.99h1c.38,0,.65-.02.81-.06.22-.05.4-.13.54-.25.14-.12.26-.31.35-.58.09-.27.14-.64.14-1.1s-.04-.82-.14-1.07c-.09-.25-.22-.44-.38-.58-.16-.14-.37-.23-.62-.28-.19-.04-.56-.06-1.1-.06h-.6Z"
          />
          <rect className="cls-2" x="38.4" y="1.55" width="1.34" height="6.02" />
          <polygon
            className="cls-2"
            points="42.52 7.57 42.52 2.56 40.55 2.56 40.55 1.55 45.84 1.55 45.84 2.56 43.87 2.56 43.87 7.57 42.52 7.57"
          />
          <polygon
            className="cls-2"
            points="46.7 7.57 46.7 1.55 51.64 1.55 51.64 2.56 48.05 2.56 48.05 3.9 51.39 3.9 51.39 4.91 48.05 4.91 48.05 6.55 51.77 6.55 51.77 7.57 46.7 7.57"
          />
          <polygon
            className="cls-2"
            points="52.23 7.57 54.5 4.43 52.44 1.55 54.01 1.55 55.35 3.48 56.65 1.55 58.21 1.55 56.14 4.47 58.42 7.57 56.79 7.57 55.32 5.49 53.84 7.57 52.23 7.57"
          />
        </g>
      </g>
    </svg>
  )
}
export const GrupoLogo90 = ({ className }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 9 64"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_11_170)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.11501 3.50505L2.11501 3.06505C2.11501 2.85505 2.08501 2.71505 2.02501 2.63505C1.96501 2.55505 1.87501 2.52505 1.77501 2.52505L1.59501 2.58505L1.47501 2.73505C1.44501 2.80505 1.43501 2.92505 1.43501 3.09505L1.43501 3.50505L2.11501 3.50505ZM3.38501 3.86505L1.13501 3.86505L1.13501 3.09505C1.13501 2.83505 1.15501 2.64505 1.19501 2.52505C1.23501 2.40505 1.31501 2.31505 1.41501 2.24505C1.51501 2.17505 1.63501 2.14505 1.74501 2.14505C1.90501 2.14505 2.05501 2.20505 2.17501 2.32505C2.29501 2.44505 2.36501 2.59505 2.38501 2.78505L2.50501 2.59505C2.59501 2.50505 2.74501 2.39505 2.95501 2.26505L3.39501 1.99505L3.39501 2.43505L3.04501 2.63505C2.76501 2.79505 2.59501 2.91505 2.52501 3.01505C2.47501 3.08505 2.44501 3.17505 2.44501 3.30505L2.44501 3.51505L3.40501 3.51505L3.40501 3.87505L3.38501 3.86505ZM0.48501 2.95505C0.48501 3.24505 0.56501 3.53505 0.71501 3.80505C0.86501 4.08505 1.08501 4.29505 1.36501 4.45505C1.64501 4.61505 1.93501 4.69505 2.24501 4.69505C2.55501 4.69505 2.83501 4.61505 3.11501 4.46505C3.39501 4.31505 3.60501 4.09505 3.76501 3.82505C3.92501 3.54505 3.99501 3.26505 3.99501 2.96505C3.99501 2.66505 3.91501 2.37505 3.76501 2.10505C3.61501 1.82505 3.39501 1.61505 3.11501 1.46505C2.83501 1.31505 2.54501 1.23505 2.24501 1.23505C1.94501 1.23505 1.64501 1.31505 1.36501 1.46505C1.08501 1.62505 0.87501 1.83505 0.71501 2.11505C0.56501 2.39505 0.48501 2.67505 0.48501 2.96505M0.13501 2.96505C0.13501 2.61505 0.22501 2.27505 0.40501 1.94505C0.58501 1.61505 0.84501 1.35505 1.17501 1.16505C1.51501 0.975054 1.85501 0.885052 2.22501 0.885052C2.59501 0.885052 2.93501 0.975052 3.26501 1.15505C3.59501 1.33505 3.85501 1.59505 4.04501 1.92505C4.22501 2.25505 4.32501 2.60505 4.32501 2.96505C4.32501 3.32505 4.23501 3.67505 4.04501 4.00505C3.86501 4.33505 3.60501 4.59505 3.26501 4.77505C2.93501 4.96505 2.58501 5.05505 2.22501 5.05505C1.86501 5.05505 1.50501 4.96505 1.17501 4.77505C0.83501 4.58505 0.58501 4.32505 0.40501 3.99505C0.22501 3.66505 0.13501 3.32505 0.13501 2.97505"
          fill="currentColor"
        />
        <path
          d="M7.51499 63.695L7.61499 63.005C7.82499 62.975 7.97499 62.895 8.06499 62.765C8.19499 62.585 8.25499 62.345 8.25499 62.045C8.25499 61.715 8.18499 61.465 8.06499 61.285C7.93499 61.105 7.75499 60.985 7.52499 60.925C7.38499 60.885 7.08499 60.875 6.63499 60.875C6.99499 61.185 7.17499 61.575 7.17499 62.035C7.17499 62.605 6.97499 63.055 6.56499 63.375C6.15499 63.695 5.67499 63.845 5.10499 63.845C4.71499 63.845 4.35499 63.775 4.02499 63.625C3.69499 63.485 3.43499 63.275 3.25499 62.995C3.07499 62.725 2.98499 62.395 2.98499 62.025C2.98499 61.535 3.18499 61.125 3.57499 60.805L3.08499 60.805L3.08499 60.155L6.61499 60.155C7.25499 60.155 7.70499 60.225 7.96499 60.355C8.23499 60.485 8.44499 60.695 8.59499 60.985C8.75499 61.275 8.82498 61.625 8.82498 62.045C8.82498 62.545 8.71499 62.945 8.49499 63.255C8.27499 63.565 7.94499 63.715 7.50499 63.705M5.04499 63.115C5.58499 63.115 5.97499 63.005 6.21499 62.785C6.45499 62.565 6.58499 62.295 6.58499 61.965C6.58499 61.635 6.46499 61.365 6.21499 61.145C5.97499 60.925 5.58499 60.815 5.06499 60.815C4.54499 60.815 4.18499 60.925 3.93499 61.155C3.67499 61.385 3.55499 61.655 3.55499 61.975C3.55499 62.295 3.68499 62.555 3.93499 62.775C4.18499 62.995 4.55499 63.105 5.05499 63.105"
          fill="currentColor"
        />
        <path
          d="M7.175 59.085L3.085 59.085L3.085 58.445L3.705 58.445C3.415 58.285 3.225 58.135 3.135 57.995C3.045 57.855 2.995 57.705 2.995 57.545C2.995 57.305 3.065 57.065 3.215 56.815L3.855 57.055C3.755 57.235 3.705 57.405 3.705 57.575C3.705 57.735 3.755 57.865 3.845 57.995C3.935 58.115 4.065 58.205 4.225 58.255C4.475 58.335 4.745 58.375 5.035 58.375L7.175 58.375L7.175 59.085Z"
          fill="currentColor"
        />
        <path
          d="M7.17501 53.655L6.57501 53.655C7.03501 53.985 7.26501 54.425 7.26501 54.985C7.26501 55.235 7.21501 55.465 7.12501 55.675C7.03501 55.885 6.91501 56.045 6.77501 56.155C6.63501 56.255 6.46501 56.335 6.25501 56.375C6.11501 56.405 5.90501 56.415 5.60501 56.415L3.07501 56.415L3.07501 55.705L5.34501 55.705C5.70501 55.705 5.95501 55.695 6.07501 55.665C6.25501 55.625 6.39501 55.525 6.50501 55.385C6.60501 55.235 6.66501 55.065 6.66501 54.845C6.66501 54.625 6.61501 54.435 6.50501 54.245C6.39501 54.065 6.25501 53.925 6.07501 53.855C5.89501 53.775 5.62501 53.735 5.27501 53.735L3.08501 53.735L3.08501 53.025L7.17501 53.025L7.17501 53.655Z"
          fill="currentColor"
        />
        <path
          d="M8.74499 51.905L3.08499 51.905L3.08499 51.255L3.61499 51.255C3.40499 51.105 3.25499 50.935 3.14499 50.745C3.04499 50.555 2.98499 50.325 2.98499 50.045C2.98499 49.685 3.07499 49.375 3.25499 49.105C3.43499 48.835 3.68499 48.625 4.01499 48.485C4.34499 48.345 4.70499 48.275 5.09499 48.275C5.51499 48.275 5.88499 48.355 6.22499 48.505C6.55499 48.655 6.81499 48.885 6.99499 49.175C7.17499 49.465 7.26499 49.775 7.26499 50.095C7.26499 50.325 7.21499 50.545 7.11499 50.735C7.01499 50.925 6.89499 51.075 6.74499 51.195L8.73499 51.195L8.73499 51.905L8.74499 51.905ZM5.15499 51.265C5.68499 51.265 6.07499 51.155 6.32499 50.935C6.57499 50.715 6.70499 50.455 6.70499 50.145C6.70499 49.835 6.57499 49.555 6.31499 49.335C6.05499 49.115 5.64499 48.995 5.10499 48.995C4.56499 48.995 4.19499 49.105 3.93499 49.325C3.67499 49.545 3.54499 49.805 3.54499 50.115C3.54499 50.425 3.68499 50.685 3.96499 50.915C4.24499 51.145 4.64499 51.265 5.16499 51.265"
          fill="currentColor"
        />
        <path
          d="M5.12499 47.6851C4.36499 47.6851 3.80499 47.4651 3.44499 47.0351C3.14499 46.6751 2.98499 46.2351 2.98499 45.7151C2.98499 45.1451 3.16499 44.6751 3.53499 44.3051C3.90499 43.9351 4.41499 43.7551 5.06499 43.7551C5.59499 43.7551 6.00499 43.8351 6.30499 43.9951C6.60499 44.1551 6.84499 44.3951 7.00499 44.6951C7.16499 44.9951 7.25499 45.3451 7.25499 45.7051C7.25499 46.2951 7.07499 46.7651 6.70499 47.1251C6.33499 47.4851 5.80499 47.6651 5.11499 47.6651M5.11499 46.9351C5.63499 46.9351 6.03499 46.8151 6.29499 46.5851C6.55499 46.3551 6.68499 46.0551 6.68499 45.7051C6.68499 45.3551 6.55499 45.0551 6.29499 44.8251C6.03499 44.5951 5.63499 44.4751 5.09499 44.4751C4.58499 44.4751 4.20499 44.5951 3.94499 44.8251C3.68499 45.0651 3.55499 45.3551 3.55499 45.7051C3.55499 46.0551 3.68499 46.3551 3.94499 46.5851C4.20499 46.8151 4.59499 46.9351 5.12499 46.9351"
          fill="currentColor"
        />
        <path
          d="M1.685 40.105L1.685 41.445L7.705 41.445L7.705 40.105L1.685 40.105Z"
          fill="currentColor"
        />
        <path
          d="M7.705 38.8051L1.685 38.8051L1.685 37.4951L5.705 34.7751L1.685 34.7751L1.685 33.5251L7.705 33.5251L7.705 34.8751L3.775 37.5551L7.705 37.5551L7.705 38.8051Z"
          fill="currentColor"
        />
        <path
          d="M1.685 32.105L1.685 29.645C1.685 29.095 1.725 28.665 1.795 28.375C1.895 27.985 2.085 27.655 2.345 27.375C2.615 27.095 2.935 26.885 3.325 26.735C3.705 26.585 4.185 26.515 4.745 26.515C5.235 26.515 5.665 26.585 6.025 26.715C6.465 26.885 6.815 27.115 7.085 27.425C7.295 27.655 7.455 27.975 7.565 28.365C7.645 28.665 7.695 29.055 7.695 29.555L7.695 32.085L1.685 32.085L1.685 32.105ZM2.705 30.765L6.695 30.765L6.695 29.765C6.695 29.385 6.675 29.115 6.635 28.955C6.585 28.735 6.505 28.555 6.385 28.415C6.265 28.275 6.075 28.155 5.805 28.065C5.535 27.975 5.165 27.925 4.705 27.925C4.245 27.925 3.885 27.965 3.635 28.065C3.385 28.155 3.195 28.285 3.055 28.445C2.915 28.605 2.825 28.815 2.775 29.065C2.735 29.255 2.715 29.625 2.715 30.165L2.715 30.765L2.705 30.765Z"
          fill="currentColor"
        />
        <path
          d="M1.685 24.0951L1.685 25.4351L7.705 25.4351L7.705 24.0951L1.685 24.0951Z"
          fill="currentColor"
        />
        <path
          d="M7.705 21.315L2.695 21.315L2.695 23.285L1.685 23.285L1.685 17.995L2.695 17.995L2.695 19.965L7.705 19.965L7.705 21.315Z"
          fill="currentColor"
        />
        <path
          d="M7.705 17.135L1.685 17.135L1.685 12.195L2.695 12.195L2.695 15.785L4.035 15.785L4.035 12.445L5.045 12.445L5.045 15.785L6.685 15.785L6.685 12.065L7.705 12.065L7.705 17.135Z"
          fill="currentColor"
        />
        <path
          d="M7.705 11.605L4.565 9.33504L1.685 11.395L1.685 9.82504L3.615 8.48504L1.685 7.18504L1.685 5.62504L4.605 7.69504L7.705 5.41504L7.705 7.04504L5.625 8.51504L7.705 9.99504L7.705 11.605Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_11_170">
          <rect
            width="62.97"
            height="8.7"
            fill="white"
            transform="translate(0.13501 63.835) rotate(-90)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export const FrLogo = ({ className }) => {
  return (
    <svg
      id="katman_2"
      data-name="katman 2"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 76.54 36.45"
    >
      <g id="katman_1" data-name="katman 1">
        <path
          className="cls-1"
          d="m75.74,23.31c0,1.88-1.56,3.42-3.49,3.42H28.76c-1.92,0-3.49-1.53-3.49-3.42v-15.24c0-1.88,1.56-3.41,3.49-3.41h17.44c.08.98.48,1.95,1.23,2.7.84.84,1.95,1.26,3.05,1.26s2.21-.42,3.05-1.26c.75-.75,1.15-1.71,1.23-2.7h17.5c1.92,0,3.49,1.53,3.49,3.41v15.24ZM47.99,1.83c.66-.66,1.55-1.03,2.49-1.03s1.82.37,2.49,1.03c1.37,1.37,1.37,3.6,0,4.97-.66.66-1.55,1.03-2.49,1.03s-1.82-.37-2.49-1.03-1.03-1.55-1.03-2.49.37-1.82,1.03-2.49m24.26,2.04h-17.51c-.1-.95-.49-1.87-1.22-2.6-.84-.84-1.95-1.26-3.05-1.26s-2.21.42-3.05,1.26c-.73.73-1.12,1.65-1.22,2.6h-17.45c-2.36,0-4.28,1.89-4.28,4.21v15.24c0,2.32,1.92,4.21,4.28,4.21h43.5c2.36,0,4.28-1.89,4.28-4.21v-15.24c0-2.32-1.92-4.21-4.28-4.21"
        />
        <polygon
          className="cls-1"
          points="48.97 4.55 49.87 4.55 49.87 4.1 48.97 4.1 48.97 3.38 50.14 3.38 50.14 2.93 48.41 2.93 48.41 5.73 48.97 5.73 48.97 4.55"
        />
        <path
          className="cls-1"
          d="m51.09,3.4h.47c.15,0,.27.04.34.11.08.07.11.17.11.3s-.04.23-.11.31c-.07.07-.19.11-.34.11h-.47v-.82Zm0,1.24h.26l.62,1.09h.65l-.67-1.13c.21-.06.37-.16.48-.31.11-.15.16-.31.16-.5,0-.16-.04-.3-.11-.43-.08-.13-.19-.23-.34-.31-.15-.08-.34-.11-.55-.11h-1.05v2.79h.56v-1.09Z"
        />
        <polygon
          className="cls-1"
          points="51.27 11.14 51.27 13.35 44.73 13.35 44.73 18.03 51.27 18.03 51.27 20.25 53.75 17.97 56.23 15.69 53.75 13.42 51.27 11.14"
        />
        <path
          className="cls-1"
          d="m15.93,21.88c-.1-.02-.84-.23-1.77-1.12-1.02-.97-1.86-2.88-.87-4.34-1.96,1.78-1.67,4.1-1.48,4.87.11.45.46,1.89,2.09,2.96l.52.29-.51.95,3.87-.79-1.37-3.74-.47.91Z"
        />
        <path
          className="cls-1"
          d="m13.26,16.49c.46,2.61,2.57,3.6,3.33,3.85.44.15,1.85.62,3.61-.19l.51-.28.52.93,1.41-3.69-3.9-.85.52.9h0c-.1.1-.67.6-1.88.91-1.37.35-3.43.04-4.13-1.58"
        />
        <path
          className="cls-1"
          d="m17.13,11.76h.01c.02.12.14.88-.26,2.08-.45,1.34-1.82,2.91-3.56,2.63,2.44,1.02,4.42-.22,5.04-.73.36-.29,1.52-1.22,1.79-3.14l.05-.59,1.06.06-2.35-3.17-2.81,2.83,1.03.05Z"
        />
        <path
          className="cls-1"
          d="m6.73,9.36c0,.89.72,1.61,1.61,1.61s1.61-.72,1.61-1.61-.72-1.61-1.61-1.61-1.61.72-1.61,1.61"
        />
        <path
          className="cls-1"
          d="m5.84,18.79c.14-.38.34-.35.34-.35,0,0,.19-.04.29.34l1.51,5.28c-1.26-.36-2.4-.99-3.37-1.81l1.24-3.46Zm4.69,6.97c.31,0,.62-.02.92-.05l.07,1.06,1.93-1.86-2.16-1.65.08,1.11c-.28.03-.56.04-.84.04-.45,0-.89-.03-1.31-.1l-.04-.28-1-8.53c-.14-1.61.78-1.87,1.35-1.63l3.19,1.28c.37.16.54-.15.54-.15,0,0,.21-.32-.16-.56,0,0-4.36-2.88-5.28-3.06-1.27-.24-2.52.79-2.8,2.12l-1.54,7.58c-1.33-1.6-2.13-3.65-2.13-5.88,0-5.07,4.12-9.19,9.19-9.19,2.71,0,5.15,1.18,6.83,3.05l.95-.96c-1.93-2.11-4.7-3.43-7.77-3.43C4.73,4.69,0,9.42,0,15.23s4.73,10.54,10.54,10.54"
        />
        <rect className="cls-1" x="65.08" y="17.04" width="1.34" height=".57" />
        <path
          className="cls-1"
          d="m71.21,21.82h-6.86v-11.35c.03-.13,0-.27-.11-.37l-1.38-1.38h6.53l1.82,1.83v11.27Zm-7.66-.2l-2.92-1.54v-9.76l1.28-1.43,1.64,1.64v11.09Zm8.45-11.32v-.04s-.02-.03-.02-.03l-.02-.04v-.02s-.06-.06-.06-.06l-2.06-2.06c-.07-.07-.18-.12-.28-.12h-7.66s-.1.02-.1.02h-.02s-.08.04-.08.04h-.02s-.07.07-.07.07l-1.66,1.85c-.07.07-.1.17-.1.27v10.15c0,.15.08.28.21.35l.19.1v.54h1.03l2.37,1.25.19.05h.05s.07,0,.07,0h.39v.43h1.05v-.43h4.78v.43h1.05v-.43h.38c.22,0,.4-.18.4-.4v-11.86s0-.05,0-.05"
        />
        <path
          className="cls-1"
          d="m65.88,11.31h3.82v1.68l-1.13-1.05h-2.69v-.63Zm-.79-.4v2.61c0,.22.18.4.4.4h4.62c.22,0,.4-.18.4-.4v-2.61c0-.22-.18-.4-.4-.4h-4.62c-.22,0-.4.18-.4.4"
        />
        <path
          className="cls-1"
          d="m3.05,33.83c-.09.17-.22.3-.37.38-.15.09-.31.13-.49.13s-.33-.04-.49-.13c-.15-.09-.28-.22-.37-.39-.09-.17-.14-.37-.14-.6s.05-.42.14-.59c.09-.17.22-.29.37-.38.15-.08.31-.13.49-.13s.34.04.49.13c.15.09.27.22.37.38.09.17.14.36.14.59s-.05.42-.14.59m.14-1.76c-.11-.15-.26-.27-.46-.38-.2-.1-.42-.15-.68-.15-.29,0-.55.07-.79.21-.24.14-.42.34-.56.59-.14.25-.21.55-.21.88s.07.62.21.89c.14.26.32.46.55.61.23.15.49.22.77.22.26,0,.49-.05.69-.15.2-.1.36-.23.47-.38v2.04h.69v-4.85h-.69v.48Z"
        />
        <path
          className="cls-1"
          d="m7.07,33.43c0,.29-.07.52-.22.68-.15.16-.35.24-.61.24s-.46-.08-.6-.24c-.15-.16-.22-.38-.22-.68v-1.83h-.68v1.93c0,.3.06.55.18.76s.28.37.48.48c.21.11.44.16.69.16.2,0,.38-.04.55-.12.17-.08.31-.18.42-.32v.39h.68v-3.29h-.68v1.83Z"
        />
        <path
          className="cls-1"
          d="m9.13,32.95c.03-.25.13-.46.3-.61s.37-.22.6-.22c.26,0,.48.08.65.23.18.15.26.35.27.6h-1.82Zm1.76-1.2c-.24-.14-.52-.2-.83-.2s-.61.07-.86.21c-.25.14-.44.34-.58.59-.14.26-.21.55-.21.89s.07.64.21.89c.14.26.34.45.58.6.25.14.53.21.84.21.39,0,.71-.1.97-.29.26-.19.44-.44.54-.74h-.73c-.15.31-.41.46-.78.46-.25,0-.47-.08-.64-.24-.18-.16-.27-.37-.29-.63h2.51c.02-.1.02-.21.02-.33,0-.32-.07-.6-.2-.84-.14-.25-.32-.43-.57-.57"
        />
        <path
          className="cls-1"
          d="m13.1,31.37c0-.19.04-.32.12-.4.08-.08.23-.12.44-.12v-.57c-.43,0-.74.09-.95.26-.2.17-.3.45-.3.83v.23h-.39v.55h.39v2.73h.69v-2.73h.61v-.55h-.61v-.23Z"
        />
        <path
          className="cls-1"
          d="m16.63,33.83c-.09.17-.22.3-.37.38-.15.09-.31.13-.49.13s-.33-.04-.49-.13c-.15-.09-.28-.22-.37-.39-.09-.17-.14-.37-.14-.6s.05-.42.14-.59c.09-.17.21-.29.37-.38.15-.08.31-.13.49-.13s.34.04.49.13c.15.09.27.22.37.38.09.17.14.36.14.59s-.05.42-.14.59m.14-1.76c-.11-.15-.27-.28-.46-.38-.19-.1-.42-.15-.68-.15-.29,0-.55.07-.78.21-.24.14-.42.34-.56.59-.14.25-.21.55-.21.88s.07.62.21.89c.14.26.32.46.56.61.23.15.49.22.78.22.25,0,.48-.05.68-.15.2-.1.36-.23.47-.39v.49h.69v-3.29h-.69v.48Z"
        />
        <rect className="cls-1" x="18.36" y="31.6" width=".68" height="3.29" />
        <path
          className="cls-1"
          d="m18.7,30.29c-.12,0-.23.04-.31.12s-.13.19-.13.31.04.23.13.31c.08.08.19.12.31.12s.22-.04.31-.12c.08-.08.12-.19.12-.31s-.04-.23-.12-.31c-.08-.08-.19-.12-.31-.12"
        />
        <path
          className="cls-1"
          d="m20.61,32.08v-.48h-.68v3.29h.68v-1.73c0-.33.07-.57.21-.7.14-.13.34-.2.61-.2h.17v-.7c-.23,0-.42.05-.59.14-.17.09-.3.22-.4.39"
        />
        <path
          className="cls-1"
          d="m22.7,32.95c.03-.25.13-.46.3-.61s.37-.22.6-.22c.26,0,.47.08.65.23s.26.35.27.6h-1.82Zm1.76-1.2c-.24-.14-.52-.2-.83-.2s-.61.07-.86.21c-.25.14-.44.34-.58.59-.14.26-.21.55-.21.89s.07.64.21.89c.14.26.34.45.58.6.25.14.53.21.85.21.38,0,.71-.1.97-.29.26-.19.44-.44.54-.74h-.73c-.15.31-.41.46-.77.46-.26,0-.47-.08-.65-.24-.18-.16-.27-.37-.29-.63h2.51c.01-.1.02-.21.02-.33,0-.32-.07-.6-.2-.84-.14-.25-.33-.43-.57-.57"
        />
        <path
          className="cls-1"
          d="m28.23,33.83c-.09.17-.22.3-.37.38-.15.09-.31.13-.49.13s-.33-.04-.49-.13c-.15-.09-.28-.22-.37-.39-.09-.17-.14-.37-.14-.6s.05-.42.14-.59c.09-.17.22-.29.37-.38.15-.08.31-.13.49-.13s.34.04.49.13c.15.09.27.21.37.38.09.17.14.36.14.59s-.05.43-.14.59m.14-1.78c-.12-.16-.29-.28-.5-.37-.21-.09-.42-.14-.64-.14-.29,0-.55.07-.79.21-.24.14-.42.34-.56.59-.14.25-.21.55-.21.88s.07.62.21.89c.14.26.32.46.56.61.24.15.5.22.78.22.25,0,.48-.05.68-.15.2-.1.35-.24.46-.4v.5h.69v-4.42h-.69v1.59Z"
        />
        <path
          className="cls-1"
          d="m30.43,32.95c.03-.25.13-.46.3-.61s.37-.22.6-.22c.26,0,.47.08.65.23s.26.35.27.6h-1.82Zm1.76-1.2c-.24-.14-.52-.2-.83-.2s-.61.07-.86.21c-.25.14-.44.34-.58.59-.14.26-.21.55-.21.89s.07.64.21.89c.14.26.34.45.58.6.25.14.53.21.84.21.39,0,.71-.1.97-.29.26-.19.44-.44.54-.74h-.73c-.15.31-.41.46-.78.46-.25,0-.47-.08-.65-.24-.17-.16-.27-.37-.29-.63h2.51c.01-.1.02-.21.02-.33,0-.32-.07-.6-.2-.84-.14-.25-.32-.43-.57-.57"
        />
        <path
          className="cls-1"
          d="m38.3,31.71c-.21-.11-.44-.16-.7-.16-.24,0-.47.06-.68.18-.21.12-.37.27-.47.47-.11-.21-.27-.37-.48-.48-.21-.11-.44-.17-.7-.17-.2,0-.38.04-.55.11-.17.08-.31.18-.42.32v-.38h-.68v3.29h.68v-1.84c0-.29.08-.52.22-.68.15-.16.35-.23.61-.23s.46.08.6.23c.15.16.22.38.22.68v1.84h.68v-1.84c0-.29.07-.52.22-.68.15-.16.35-.23.61-.23s.45.08.6.23c.15.16.22.38.22.68v1.84h.67v-1.94c0-.3-.06-.55-.18-.76-.12-.21-.28-.37-.48-.48"
        />
        <path
          className="cls-1"
          d="m40.31,32.95c.03-.25.13-.46.3-.61s.37-.22.6-.22c.26,0,.48.08.65.23.18.15.26.35.27.6h-1.82Zm1.76-1.2c-.24-.14-.52-.2-.83-.2s-.61.07-.86.21c-.25.14-.44.34-.58.59-.14.26-.21.55-.21.89s.07.64.21.89c.14.26.34.45.59.6.25.14.53.21.84.21.39,0,.71-.1.97-.29.26-.19.44-.44.54-.74h-.73c-.15.31-.41.46-.78.46-.26,0-.47-.08-.65-.24-.18-.16-.27-.37-.29-.63h2.51c.02-.1.02-.21.02-.33,0-.32-.07-.6-.2-.84-.14-.25-.32-.43-.57-.57"
        />
        <path
          className="cls-1"
          d="m45.39,33.17c-.15-.07-.35-.13-.59-.19-.18-.05-.31-.09-.41-.13-.09-.03-.17-.08-.23-.14l-.1-.22c0-.11.05-.2.14-.27.09-.07.23-.1.41-.1s.33.04.44.13c.11.09.17.21.18.35h.68c-.01-.33-.14-.58-.37-.77-.23-.19-.53-.28-.9-.28-.25,0-.47.04-.67.12-.19.08-.34.2-.44.34-.1.14-.16.3-.16.48,0,.21.06.39.17.52.11.13.25.23.4.29.15.06.35.13.6.2.25.07.44.14.56.2.12.06.18.15.18.27,0,.11-.05.21-.16.28-.11.07-.25.11-.45.11s-.33-.05-.46-.14c-.12-.09-.19-.21-.2-.35h-.7c0,.2.07.38.19.54.12.16.28.29.49.38.2.09.44.14.7.14s.47-.04.66-.12c.19-.08.34-.2.44-.35.1-.15.16-.32.16-.5,0-.21-.06-.38-.17-.51-.11-.13-.24-.22-.4-.29"
        />
        <path
          className="cls-1"
          d="m49.02,33.83c-.09.17-.22.3-.37.38-.15.09-.32.13-.49.13s-.33-.04-.49-.13c-.15-.09-.28-.22-.37-.39-.09-.17-.14-.37-.14-.6s.05-.42.14-.59c.09-.17.22-.29.37-.38.15-.08.31-.13.49-.13s.34.04.49.13c.15.09.27.21.37.38.09.17.14.36.14.59s-.05.43-.14.59m.14-1.78c-.12-.16-.29-.28-.5-.37-.21-.09-.42-.14-.64-.14-.29,0-.56.07-.79.21-.24.14-.42.34-.56.59-.14.25-.21.55-.21.88s.07.62.21.89c.14.26.32.46.56.61.24.15.5.22.78.22.25,0,.48-.05.68-.15.2-.1.35-.24.46-.4v.5h.69v-4.42h-.69v1.59Z"
        />
        <path
          className="cls-1"
          d="m51.22,32.95c.03-.25.13-.46.3-.61.17-.15.37-.22.6-.22.26,0,.47.08.65.23s.26.35.27.6h-1.82Zm1.76-1.2c-.24-.14-.52-.2-.83-.2s-.61.07-.86.21c-.25.14-.44.34-.58.59-.14.26-.21.55-.21.89s.07.64.21.89c.14.26.34.45.59.6.25.14.53.21.84.21.39,0,.71-.1.97-.29.26-.19.44-.44.54-.74h-.73c-.15.31-.41.46-.78.46-.26,0-.47-.08-.65-.24-.18-.16-.27-.37-.29-.63h2.51c.01-.1.02-.21.02-.33,0-.32-.07-.6-.2-.84-.14-.25-.32-.43-.57-.57"
        />
        <path
          className="cls-1"
          d="m55.81,32.12c.2,0,.36.05.49.14.13.09.23.22.29.38h.73c-.09-.35-.27-.62-.53-.81-.26-.19-.59-.28-.99-.28-.31,0-.59.07-.84.21-.24.14-.43.34-.57.59-.14.26-.21.55-.21.89s.07.64.21.89c.14.26.33.45.57.6.24.14.52.21.84.21.39,0,.72-.1.98-.29.26-.2.44-.46.54-.8h-.73c-.13.35-.39.52-.78.52-.28,0-.5-.1-.67-.3-.17-.2-.25-.47-.25-.83s.08-.63.25-.83c.17-.2.39-.3.67-.3"
        />
        <path
          className="cls-1"
          d="m60.37,31.71c-.2-.11-.42-.16-.67-.16-.21,0-.41.04-.58.11-.18.08-.32.18-.44.32v-1.51h-.68v4.42h.68v-1.84c0-.29.08-.52.23-.68.15-.16.35-.23.6-.23s.46.08.6.23c.15.16.22.38.22.68v1.84h.67v-1.94c0-.3-.06-.55-.17-.76-.11-.21-.27-.37-.46-.48"
        />
        <path
          className="cls-1"
          d="m62.36,32.95c.03-.25.13-.46.3-.61s.37-.22.6-.22c.26,0,.48.08.65.23s.26.35.27.6h-1.82Zm1.76-1.2c-.24-.14-.52-.2-.83-.2s-.61.07-.86.21c-.25.14-.44.34-.58.59-.14.26-.21.55-.21.89s.07.64.21.89c.14.26.34.45.59.6.25.14.53.21.84.21.39,0,.71-.1.97-.29.26-.19.44-.44.54-.74h-.73c-.15.31-.41.46-.78.46-.25,0-.47-.08-.65-.24-.17-.16-.27-.37-.29-.63h2.51c.01-.1.02-.21.02-.33,0-.32-.07-.6-.2-.84-.14-.25-.32-.43-.57-.57"
        />
        <path
          className="cls-1"
          d="m66.35,30.78h-.69v.82h-.39v.56h.39v1.82c0,.32.08.55.25.7.16.14.4.21.7.21h.54v-.57h-.42c-.14,0-.24-.03-.3-.08-.06-.05-.09-.14-.09-.27v-1.82h.8v-.56h-.8v-.82Z"
        />
        <path
          className="cls-1"
          d="m69.66,33.17c-.15-.07-.35-.13-.59-.19-.18-.05-.31-.09-.41-.13-.09-.03-.17-.08-.23-.14l-.1-.22c0-.11.05-.2.14-.27.09-.07.23-.1.41-.1s.33.04.44.13c.11.09.17.21.18.35h.68c-.02-.33-.14-.58-.37-.77-.23-.19-.53-.28-.9-.28-.25,0-.47.04-.67.12-.19.08-.34.2-.44.34-.1.14-.16.3-.16.48,0,.21.06.39.17.52.11.13.25.23.4.29.15.06.35.13.6.2.25.07.44.14.56.2.12.06.18.15.18.27,0,.11-.05.21-.16.28-.11.07-.25.11-.44.11s-.33-.05-.46-.14c-.12-.09-.19-.21-.2-.35h-.7c0,.2.07.38.19.54.12.16.28.29.49.38.21.09.44.14.7.14s.48-.04.67-.12c.19-.08.33-.2.44-.35.1-.15.16-.32.16-.5,0-.21-.06-.38-.17-.51-.11-.13-.24-.22-.4-.29"
        />
        <path
          className="cls-1"
          d="m71.24,34.06c-.12,0-.23.04-.31.12-.08.08-.12.19-.12.31s.04.23.12.31c.08.08.19.12.31.12s.22-.04.3-.12c.08-.08.12-.19.12-.31s-.04-.23-.12-.31c-.08-.08-.19-.12-.3-.12"
        />
        <path
          className="cls-1"
          d="m73.17,31.37c0-.19.04-.32.12-.4.08-.08.23-.12.44-.12v-.57c-.43,0-.74.09-.95.26-.2.17-.3.45-.3.83v.23h-.39v.55h.39v2.73h.69v-2.73h.61v-.55h-.61v-.23Z"
        />
        <path
          className="cls-1"
          d="m75.06,32.08v-.48h-.68v3.29h.68v-1.73c0-.33.07-.57.21-.7.14-.13.34-.2.61-.2h.17v-.7c-.23,0-.42.05-.59.14-.17.09-.3.22-.4.39"
        />
        <path
          className="cls-1"
          d="m39.45,15.02l-.54-.54c-.12-.12-.29-.15-.45-.09-.15.06-.25.21-.25.38v6.1h-6.46v-6.1c0-.17-.1-.32-.25-.38-.15-.06-.33-.03-.45.09l-.54.54-1.38-1.38,2.44-2.44,1.43-.59c.45.56,1.19.91,1.98.91s1.53-.35,1.98-.92l1.42.59,2.45,2.45-1.38,1.38Zm-.54-4.46l-.13-.09-1.8-.74-.17-.03c-.15,0-.29.08-.36.22-.26.48-.83.79-1.46.79s-1.2-.31-1.46-.79c-.1-.18-.34-.26-.53-.18l-1.81.75-.13.09-2.79,2.79c-.08.08-.12.18-.12.29s.04.21.12.29l1.96,1.96c.16.16.42.16.58,0l.12-.12v5.52c0,.23.18.41.41.41h7.27c.23,0,.41-.18.41-.41v-5.52l.13.13c.08.08.18.12.29.12s.21-.04.29-.12l1.96-1.96c.08-.08.12-.18.12-.29s-.04-.21-.12-.29l-2.79-2.79Z"
        />
      </g>
    </svg>
  )
}



export const ZaraQr = ({ className }) => {
  return (
    <svg
      id="katman_2"
      className={className}
      data-name="katman 2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-3 -3 42.04 42.04"
    >
      <g id="Layer_1" data-name="Layer 1">
        <rect
          className="cls-1"
          x="10.88"
          y=".16"
          width=".76"
          height=".76"
          transform="translate(2.92 8.12) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="15.17"
          y=".16"
          width=".76"
          height=".76"
          transform="translate(4.18 11.15) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="17.32"
          y=".16"
          width=".76"
          height=".76"
          transform="translate(4.8 12.67) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="18.39"
          y=".16"
          width=".76"
          height=".76"
          transform="translate(5.12 13.43) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="19.46"
          y=".16"
          width=".76"
          height=".76"
          transform="translate(5.43 14.19) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="21.61"
          y=".16"
          width=".76"
          height=".76"
          transform="translate(6.06 15.7) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="22.68"
          y=".16"
          width=".76"
          height=".76"
          transform="translate(6.37 16.46) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="24.83"
          y=".16"
          width=".76"
          height=".76"
          transform="translate(7 17.98) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="25.9"
          y=".16"
          width=".76"
          height=".76"
          transform="translate(7.32 18.74) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="11.96"
          y="1.23"
          width=".76"
          height=".76"
          transform="translate(2.48 9.19) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="13.03"
          y="1.23"
          width=".76"
          height=".76"
          transform="translate(2.79 9.95) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="14.1"
          y="1.23"
          width=".76"
          height=".76"
          transform="translate(3.1 10.71) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="16.25"
          y="1.23"
          width=".76"
          height=".76"
          transform="translate(3.73 12.23) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="19.46"
          y="1.23"
          width=".76"
          height=".76"
          transform="translate(4.67 14.5) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="20.54"
          y="1.23"
          width=".76"
          height=".76"
          transform="translate(4.99 15.26) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="21.61"
          y="1.23"
          width=".76"
          height=".76"
          transform="translate(5.3 16.02) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="24.83"
          y="1.23"
          width=".76"
          height=".76"
          transform="translate(6.24 18.29) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="9.81"
          y="2.3"
          width=".76"
          height=".76"
          transform="translate(1.09 7.99) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="11.96"
          y="2.3"
          width=".76"
          height=".76"
          transform="translate(1.72 9.51) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="13.03"
          y="2.3"
          width=".76"
          height=".76"
          transform="translate(2.03 10.27) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="19.46"
          y="2.3"
          width=".76"
          height=".76"
          transform="translate(3.92 14.82) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="20.54"
          y="2.3"
          width=".76"
          height=".76"
          transform="translate(4.23 15.58) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="24.83"
          y="2.3"
          width=".76"
          height=".76"
          transform="translate(5.49 18.61) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="9.81"
          y="3.37"
          width=".76"
          height=".76"
          transform="translate(.33 8.3) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="10.88"
          y="3.37"
          width=".76"
          height=".76"
          transform="translate(.64 9.06) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="16.25"
          y="3.37"
          width=".76"
          height=".76"
          transform="translate(2.22 12.86) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="18.39"
          y="3.37"
          width=".76"
          height=".76"
          transform="translate(2.84 14.37) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="20.54"
          y="3.37"
          width=".76"
          height=".76"
          transform="translate(3.47 15.89) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="24.83"
          y="3.37"
          width=".76"
          height=".76"
          transform="translate(4.73 18.92) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="25.9"
          y="3.37"
          width=".76"
          height=".76"
          transform="translate(5.04 19.68) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="8.74"
          y="4.45"
          width=".76"
          height=".76"
          transform="translate(-.74 7.86) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="9.81"
          y="4.45"
          width=".76"
          height=".76"
          transform="translate(-.43 8.62) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="11.96"
          y="4.45"
          width=".76"
          height=".76"
          transform="translate(.2 10.14) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="14.1"
          y="4.45"
          width=".76"
          height=".76"
          transform="translate(.83 11.65) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="15.17"
          y="4.45"
          width=".76"
          height=".76"
          transform="translate(1.14 12.41) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="17.32"
          y="4.45"
          width=".76"
          height=".76"
          transform="translate(1.77 13.93) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="18.39"
          y="4.45"
          width=".76"
          height=".76"
          transform="translate(2.08 14.69) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="19.46"
          y="4.45"
          width=".76"
          height=".76"
          transform="translate(2.4 15.45) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="20.54"
          y="4.45"
          width=".76"
          height=".76"
          transform="translate(2.71 16.2) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="24.83"
          y="4.45"
          width=".76"
          height=".76"
          transform="translate(3.97 19.24) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="25.9"
          y="4.45"
          width=".76"
          height=".76"
          transform="translate(4.28 20) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="11.96"
          y="5.52"
          width=".76"
          height=".76"
          transform="translate(-.56 10.45) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="14.1"
          y="5.52"
          width=".76"
          height=".76"
          transform="translate(.07 11.97) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="18.39"
          y="5.52"
          width=".76"
          height=".76"
          transform="translate(1.33 15) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="19.46"
          y="5.52"
          width=".76"
          height=".76"
          transform="translate(1.64 15.76) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="21.61"
          y="5.52"
          width=".76"
          height=".76"
          transform="translate(2.27 17.28) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="22.68"
          y="5.52"
          width=".76"
          height=".76"
          transform="translate(2.58 18.03) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="24.83"
          y="5.52"
          width=".76"
          height=".76"
          transform="translate(3.21 19.55) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="8.74"
          y="6.59"
          width=".76"
          height=".76"
          transform="translate(-2.26 8.49) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="10.88"
          y="6.59"
          width=".76"
          height=".76"
          transform="translate(-1.63 10.01) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="13.03"
          y="6.59"
          width=".76"
          height=".76"
          transform="translate(-1 11.52) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="15.17"
          y="6.59"
          width=".76"
          height=".76"
          transform="translate(-.37 13.04) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="17.32"
          y="6.59"
          width=".76"
          height=".76"
          transform="translate(.25 14.56) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="19.46"
          y="6.59"
          width=".76"
          height=".76"
          transform="translate(.88 16.07) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="21.61"
          y="6.59"
          width=".76"
          height=".76"
          transform="translate(1.51 17.59) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="23.75"
          y="6.59"
          width=".76"
          height=".76"
          transform="translate(2.14 19.11) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="25.9"
          y="6.59"
          width=".76"
          height=".76"
          transform="translate(2.77 20.62) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="8.74"
          y="7.67"
          width=".76"
          height=".76"
          transform="translate(-3.02 8.8) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="10.88"
          y="7.67"
          width=".76"
          height=".76"
          transform="translate(-2.39 10.32) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="16.25"
          y="7.67"
          width=".76"
          height=".76"
          transform="translate(-.82 14.11) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="17.32"
          y="7.67"
          width=".76"
          height=".76"
          transform="translate(-.5 14.87) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="18.39"
          y="7.67"
          width=".76"
          height=".76"
          transform="translate(-.19 15.63) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="19.46"
          y="7.67"
          width=".76"
          height=".76"
          transform="translate(.12 16.39) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="21.61"
          y="7.67"
          width=".76"
          height=".76"
          transform="translate(.75 17.9) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="23.75"
          y="7.67"
          width=".76"
          height=".76"
          transform="translate(1.38 19.42) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="25.9"
          y="7.67"
          width=".76"
          height=".76"
          transform="translate(2.01 20.94) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="2.3"
          y="8.74"
          width=".76"
          height=".76"
          transform="translate(-5.66 4.57) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="3.38"
          y="8.74"
          width=".76"
          height=".76"
          transform="translate(-5.35 5.32) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="6.59"
          y="8.74"
          width=".76"
          height=".76"
          transform="translate(-4.4 7.6) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="7.67"
          y="8.74"
          width=".76"
          height=".76"
          transform="translate(-4.09 8.36) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="8.74"
          y="8.74"
          width=".76"
          height=".76"
          transform="translate(-3.78 9.12) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="13.03"
          y="8.74"
          width=".76"
          height=".76"
          transform="translate(-2.52 12.15) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="16.25"
          y="8.74"
          width=".76"
          height=".76"
          transform="translate(-1.58 14.43) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="18.39"
          y="8.74"
          width=".76"
          height=".76"
          transform="translate(-.95 15.94) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="20.54"
          y="8.74"
          width=".76"
          height=".76"
          transform="translate(-.32 17.46) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="21.61"
          y="8.74"
          width=".76"
          height=".76"
          transform="translate(0 18.22) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="22.68"
          y="8.74"
          width=".76"
          height=".76"
          transform="translate(.31 18.98) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="23.75"
          y="8.74"
          width=".76"
          height=".76"
          transform="translate(.62 19.73) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="24.83"
          y="8.74"
          width=".76"
          height=".76"
          transform="translate(.94 20.49) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="26.97"
          y="8.74"
          width=".76"
          height=".76"
          transform="translate(1.56 22.01) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="28.04"
          y="8.74"
          width=".76"
          height=".76"
          transform="translate(1.88 22.77) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="30.19"
          y="8.74"
          width=".76"
          height=".76"
          transform="translate(2.51 24.29) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="1.23"
          y="9.81"
          width=".76"
          height=".76"
          transform="translate(-6.73 4.12) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="2.3"
          y="9.81"
          width=".76"
          height=".76"
          transform="translate(-6.42 4.88) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="3.38"
          y="9.81"
          width=".76"
          height=".76"
          transform="translate(-6.11 5.64) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="5.52"
          y="9.81"
          width=".76"
          height=".76"
          transform="translate(-5.48 7.15) rotate(-44.99)"
        />
        <rect
          className="cls-1"
          x="9.81"
          y="9.81"
          width=".76"
          height=".76"
          transform="translate(-4.22 10.19) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="13.03"
          y="9.81"
          width=".76"
          height=".76"
          transform="translate(-3.28 12.46) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="14.1"
          y="9.81"
          width=".76"
          height=".76"
          transform="translate(-2.96 13.22) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="16.25"
          y="9.81"
          width=".76"
          height=".76"
          transform="translate(-2.34 14.74) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="17.32"
          y="9.81"
          width=".76"
          height=".76"
          transform="translate(-2.02 15.5) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="20.54"
          y="9.81"
          width=".76"
          height=".76"
          transform="translate(-1.08 17.77) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="21.61"
          y="9.81"
          width=".76"
          height=".76"
          transform="translate(-.76 18.53) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="22.68"
          y="9.81"
          width=".76"
          height=".76"
          transform="translate(-.45 19.29) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="24.83"
          y="9.81"
          width=".76"
          height=".76"
          transform="translate(.18 20.81) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="26.97"
          y="9.81"
          width=".76"
          height=".76"
          transform="translate(.81 22.32) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="28.04"
          y="9.81"
          width=".76"
          height=".76"
          transform="translate(1.12 23.08) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="31.26"
          y="9.81"
          width=".76"
          height=".76"
          transform="translate(2.06 25.36) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="33.41"
          y="9.81"
          width=".76"
          height=".76"
          transform="translate(2.69 26.87) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="34.48"
          y="9.81"
          width=".76"
          height=".76"
          transform="translate(3 27.63) rotate(-45)"
        />
        <rect
          className="cls-1"
          x=".16"
          y="10.88"
          width=".76"
          height=".76"
          transform="translate(-7.81 3.68) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="1.23"
          y="10.88"
          width=".76"
          height=".76"
          transform="translate(-7.49 4.44) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="3.38"
          y="10.88"
          width=".76"
          height=".76"
          transform="translate(-6.86 5.95) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="6.59"
          y="10.88"
          width=".76"
          height=".76"
          transform="translate(-5.92 8.23) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="10.88"
          y="10.88"
          width=".76"
          height=".76"
          transform="translate(-4.66 11.26) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="11.96"
          y="10.88"
          width=".76"
          height=".76"
          transform="translate(-4.35 12.02) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="14.1"
          y="10.88"
          width=".76"
          height=".76"
          transform="translate(-3.72 13.54) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="15.17"
          y="10.88"
          width=".76"
          height=".76"
          transform="translate(-3.41 14.3) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="16.25"
          y="10.88"
          width=".76"
          height=".76"
          transform="translate(-3.09 15.05) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="20.54"
          y="10.88"
          width=".76"
          height=".76"
          transform="translate(-1.84 18.09) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="21.61"
          y="10.88"
          width=".76"
          height=".76"
          transform="translate(-1.52 18.85) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="24.83"
          y="10.88"
          width=".76"
          height=".76"
          transform="translate(-.58 21.12) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="31.26"
          y="10.88"
          width=".76"
          height=".76"
          transform="translate(1.3 25.67) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="33.41"
          y="10.88"
          width=".76"
          height=".76"
          transform="translate(1.93 27.19) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="34.48"
          y="10.88"
          width=".76"
          height=".76"
          transform="translate(2.25 27.95) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="1.23"
          y="11.96"
          width=".76"
          height=".76"
          transform="translate(-8.25 4.75) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="2.3"
          y="11.96"
          width=".76"
          height=".76"
          transform="translate(-7.94 5.51) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="4.45"
          y="11.96"
          width=".76"
          height=".76"
          transform="translate(-7.31 7.03) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="7.67"
          y="11.96"
          width=".76"
          height=".76"
          transform="translate(-6.37 9.3) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="9.81"
          y="11.96"
          width=".76"
          height=".76"
          transform="translate(-5.74 10.82) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="10.88"
          y="11.96"
          width=".76"
          height=".76"
          transform="translate(-5.42 11.58) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="24.83"
          y="11.96"
          width=".76"
          height=".76"
          transform="translate(-1.34 21.44) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="25.9"
          y="11.96"
          width=".76"
          height=".76"
          transform="translate(-1.03 22.19) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="26.97"
          y="11.96"
          width=".76"
          height=".76"
          transform="translate(-.71 22.95) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="28.04"
          y="11.96"
          width=".76"
          height=".76"
          transform="translate(-.4 23.71) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="29.12"
          y="11.96"
          width=".76"
          height=".76"
          transform="translate(-.08 24.47) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="30.19"
          y="11.96"
          width=".76"
          height=".76"
          transform="translate(.23 25.23) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="31.26"
          y="11.96"
          width=".76"
          height=".76"
          transform="translate(.55 25.99) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="1.23"
          y="13.03"
          width=".76"
          height=".76"
          transform="translate(-9.01 5.06) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="2.3"
          y="13.03"
          width=".76"
          height=".76"
          transform="translate(-8.69 5.82) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="6.59"
          y="13.03"
          width=".76"
          height=".76"
          transform="translate(-7.44 8.86) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="8.74"
          y="13.03"
          width=".76"
          height=".76"
          transform="translate(-6.81 10.37) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="10.88"
          y="13.03"
          width=".76"
          height=".76"
          transform="translate(-6.18 11.89) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="24.83"
          y="13.03"
          width=".76"
          height=".76"
          transform="translate(-2.1 21.75) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="25.9"
          y="13.03"
          width=".76"
          height=".76"
          transform="translate(-1.78 22.51) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="26.97"
          y="13.03"
          width=".76"
          height=".76"
          transform="translate(-1.47 23.27) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="29.12"
          y="13.03"
          width=".76"
          height=".76"
          transform="translate(-.84 24.78) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="8.74"
          y="14.1"
          width=".76"
          height=".76"
          transform="translate(-7.57 10.69) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="10.88"
          y="14.1"
          width=".76"
          height=".76"
          transform="translate(-6.94 12.2) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="23.75"
          y="14.1"
          width=".76"
          height=".76"
          transform="translate(-3.17 21.31) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="25.9"
          y="14.1"
          width=".76"
          height=".76"
          transform="translate(-2.54 22.82) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="31.26"
          y="14.1"
          width=".76"
          height=".76"
          transform="translate(-.97 26.61) rotate(-45)"
        />
        <rect
          className="cls-1"
          x=".16"
          y="15.17"
          width=".76"
          height=".76"
          transform="translate(-10.84 4.93) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="1.23"
          y="15.17"
          width=".76"
          height=".76"
          transform="translate(-10.53 5.69) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="4.45"
          y="15.17"
          width=".76"
          height=".76"
          transform="translate(-9.58 7.97) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="5.52"
          y="15.17"
          width=".76"
          height=".76"
          transform="translate(-9.27 8.72) rotate(-44.99)"
        />
        <rect
          className="cls-1"
          x="6.59"
          y="15.17"
          width=".76"
          height=".76"
          transform="translate(-8.96 9.49) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="7.67"
          y="15.17"
          width=".76"
          height=".76"
          transform="translate(-8.64 10.24) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="9.81"
          y="15.17"
          width=".76"
          height=".76"
          transform="translate(-8.01 11.76) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="26.97"
          y="15.17"
          width=".76"
          height=".76"
          transform="translate(-2.99 23.9) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="28.04"
          y="15.17"
          width=".76"
          height=".76"
          transform="translate(-2.67 24.65) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="29.12"
          y="15.17"
          width=".76"
          height=".76"
          transform="translate(-2.36 25.41) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="30.19"
          y="15.17"
          width=".76"
          height=".76"
          transform="translate(-2.04 26.17) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="31.26"
          y="15.17"
          width=".76"
          height=".76"
          transform="translate(-1.73 26.93) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="4.45"
          y="16.25"
          width=".76"
          height=".76"
          transform="translate(-10.34 8.28) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="5.52"
          y="16.25"
          width=".76"
          height=".76"
          transform="translate(-10.03 9.04) rotate(-44.99)"
        />
        <rect
          className="cls-1"
          x="7.67"
          y="16.25"
          width=".76"
          height=".76"
          transform="translate(-9.4 10.56) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="9.81"
          y="16.25"
          width=".76"
          height=".76"
          transform="translate(-8.77 12.07) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="10.88"
          y="16.25"
          width=".76"
          height=".76"
          transform="translate(-8.46 12.83) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="23.75"
          y="16.25"
          width=".76"
          height=".76"
          transform="translate(-4.69 21.93) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="24.83"
          y="16.25"
          width=".76"
          height=".76"
          transform="translate(-4.37 22.69) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="25.9"
          y="16.25"
          width=".76"
          height=".76"
          transform="translate(-4.06 23.45) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="31.26"
          y="16.25"
          width=".76"
          height=".76"
          transform="translate(-2.49 27.24) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="32.33"
          y="16.25"
          width=".76"
          height=".76"
          transform="translate(-2.17 28) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="33.41"
          y="16.25"
          width=".76"
          height=".76"
          transform="translate(-1.86 28.76) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="1.23"
          y="17.32"
          width=".76"
          height=".76"
          transform="translate(-12.04 6.32) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="3.38"
          y="17.32"
          width=".76"
          height=".76"
          transform="translate(-11.41 7.84) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="5.52"
          y="17.32"
          width=".76"
          height=".76"
          transform="translate(-10.79 9.35) rotate(-44.99)"
        />
        <rect
          className="cls-1"
          x="6.59"
          y="17.32"
          width=".76"
          height=".76"
          transform="translate(-10.47 10.11) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="10.88"
          y="17.32"
          width=".76"
          height=".76"
          transform="translate(-9.22 13.15) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="24.83"
          y="17.32"
          width=".76"
          height=".76"
          transform="translate(-5.13 23.01) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="25.9"
          y="17.32"
          width=".76"
          height=".76"
          transform="translate(-4.82 23.76) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="26.97"
          y="17.32"
          width=".76"
          height=".76"
          transform="translate(-4.5 24.52) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="28.04"
          y="17.32"
          width=".76"
          height=".76"
          transform="translate(-4.19 25.28) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="30.19"
          y="17.32"
          width=".76"
          height=".76"
          transform="translate(-3.56 26.8) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="32.33"
          y="17.32"
          width=".76"
          height=".76"
          transform="translate(-2.93 28.31) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="33.41"
          y="17.32"
          width=".76"
          height=".76"
          transform="translate(-2.62 29.07) rotate(-45)"
        />
        <rect
          className="cls-1"
          x=".16"
          y="18.39"
          width=".76"
          height=".76"
          transform="translate(-13.12 5.88) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="1.23"
          y="18.39"
          width=".76"
          height=".76"
          transform="translate(-12.8 6.64) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="2.3"
          y="18.39"
          width=".76"
          height=".76"
          transform="translate(-12.49 7.39) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="5.52"
          y="18.39"
          width=".76"
          height=".76"
          transform="translate(-11.54 9.67) rotate(-44.99)"
        />
        <rect
          className="cls-1"
          x="7.67"
          y="18.39"
          width=".76"
          height=".76"
          transform="translate(-10.92 11.19) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="8.74"
          y="18.39"
          width=".76"
          height=".76"
          transform="translate(-10.6 11.94) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="9.81"
          y="18.39"
          width=".76"
          height=".76"
          transform="translate(-10.29 12.7) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="23.75"
          y="18.39"
          width=".76"
          height=".76"
          transform="translate(-6.2 22.56) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="24.83"
          y="18.39"
          width=".76"
          height=".76"
          transform="translate(-5.89 23.32) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="26.97"
          y="18.39"
          width=".76"
          height=".76"
          transform="translate(-5.26 24.84) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="28.04"
          y="18.39"
          width=".76"
          height=".76"
          transform="translate(-4.95 25.59) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="29.12"
          y="18.39"
          width=".76"
          height=".76"
          transform="translate(-4.63 26.35) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="30.19"
          y="18.39"
          width=".76"
          height=".76"
          transform="translate(-4.32 27.11) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="32.33"
          y="18.39"
          width=".76"
          height=".76"
          transform="translate(-3.69 28.63) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="33.41"
          y="18.39"
          width=".76"
          height=".76"
          transform="translate(-3.38 29.39) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="34.48"
          y="18.39"
          width=".76"
          height=".76"
          transform="translate(-3.06 30.14) rotate(-45)"
        />
        <rect
          className="cls-1"
          x=".16"
          y="19.46"
          width=".76"
          height=".76"
          transform="translate(-13.87 6.19) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="2.3"
          y="19.46"
          width=".76"
          height=".76"
          transform="translate(-13.25 7.71) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="3.38"
          y="19.46"
          width=".76"
          height=".76"
          transform="translate(-12.93 8.47) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="5.52"
          y="19.46"
          width=".76"
          height=".76"
          transform="translate(-12.3 9.98) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="6.59"
          y="19.46"
          width=".76"
          height=".76"
          transform="translate(-11.99 10.74) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="10.88"
          y="19.46"
          width=".76"
          height=".76"
          transform="translate(-10.73 13.78) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="23.75"
          y="19.46"
          width=".76"
          height=".76"
          transform="translate(-6.96 22.88) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="26.97"
          y="19.46"
          width=".76"
          height=".76"
          transform="translate(-6.02 25.15) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="28.04"
          y="19.46"
          width=".76"
          height=".76"
          transform="translate(-5.71 25.91) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="29.12"
          y="19.46"
          width=".76"
          height=".76"
          transform="translate(-5.39 26.67) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="32.33"
          y="19.46"
          width=".76"
          height=".76"
          transform="translate(-4.45 28.94) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="33.41"
          y="19.46"
          width=".76"
          height=".76"
          transform="translate(-4.13 29.7) rotate(-45)"
        />
        <rect
          className="cls-1"
          x=".16"
          y="20.54"
          width=".76"
          height=".76"
          transform="translate(-14.63 6.51) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="2.3"
          y="20.54"
          width=".76"
          height=".76"
          transform="translate(-14 8.02) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="3.38"
          y="20.54"
          width=".76"
          height=".76"
          transform="translate(-13.69 8.78) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="10.88"
          y="20.54"
          width=".76"
          height=".76"
          transform="translate(-11.49 14.09) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="23.75"
          y="20.54"
          width=".76"
          height=".76"
          transform="translate(-7.72 23.19) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="29.12"
          y="20.54"
          width=".76"
          height=".76"
          transform="translate(-6.15 26.98) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="33.41"
          y="20.54"
          width=".76"
          height=".76"
          transform="translate(-4.89 30.02) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="1.23"
          y="21.61"
          width=".76"
          height=".76"
          transform="translate(-15.08 7.58) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="2.3"
          y="21.61"
          width=".76"
          height=".76"
          transform="translate(-14.76 8.34) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="4.45"
          y="21.61"
          width=".76"
          height=".76"
          transform="translate(-14.13 9.85) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="5.52"
          y="21.61"
          width=".76"
          height=".76"
          transform="translate(-13.82 10.61) rotate(-44.99)"
        />
        <rect
          className="cls-1"
          x="6.59"
          y="21.61"
          width=".76"
          height=".76"
          transform="translate(-13.51 11.37) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="8.74"
          y="21.61"
          width=".76"
          height=".76"
          transform="translate(-12.88 12.89) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="10.88"
          y="21.61"
          width=".76"
          height=".76"
          transform="translate(-12.25 14.4) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="25.9"
          y="21.61"
          width=".76"
          height=".76"
          transform="translate(-7.85 25.02) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="28.04"
          y="21.61"
          width=".76"
          height=".76"
          transform="translate(-7.22 26.54) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="29.12"
          y="21.61"
          width=".76"
          height=".76"
          transform="translate(-6.91 27.3) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="31.26"
          y="21.61"
          width=".76"
          height=".76"
          transform="translate(-6.28 28.81) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="32.33"
          y="21.61"
          width=".76"
          height=".76"
          transform="translate(-5.97 29.57) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="33.41"
          y="21.61"
          width=".76"
          height=".76"
          transform="translate(-5.65 30.33) rotate(-45)"
        />
        <rect
          className="cls-1"
          x=".16"
          y="22.68"
          width=".76"
          height=".76"
          transform="translate(-16.15 7.13) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="2.3"
          y="22.68"
          width=".76"
          height=".76"
          transform="translate(-15.52 8.65) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="7.67"
          y="22.68"
          width=".76"
          height=".76"
          transform="translate(-13.95 12.44) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="9.81"
          y="22.68"
          width=".76"
          height=".76"
          transform="translate(-13.32 13.96) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="25.9"
          y="22.68"
          width=".76"
          height=".76"
          transform="translate(-8.61 25.34) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="32.33"
          y="22.68"
          width=".76"
          height=".76"
          transform="translate(-6.72 29.88) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="34.48"
          y="22.68"
          width=".76"
          height=".76"
          transform="translate(-6.1 31.4) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="3.38"
          y="23.75"
          width=".76"
          height=".76"
          transform="translate(-15.96 9.72) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="4.45"
          y="23.75"
          width=".76"
          height=".76"
          transform="translate(-15.65 10.48) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="5.52"
          y="23.75"
          width=".76"
          height=".76"
          transform="translate(-15.34 11.24) rotate(-44.99)"
        />
        <rect
          className="cls-1"
          x="6.59"
          y="23.75"
          width=".76"
          height=".76"
          transform="translate(-15.02 12) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="7.67"
          y="23.75"
          width=".76"
          height=".76"
          transform="translate(-14.71 12.76) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="8.74"
          y="23.75"
          width=".76"
          height=".76"
          transform="translate(-14.39 13.52) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="11.96"
          y="23.75"
          width=".76"
          height=".76"
          transform="translate(-13.45 15.79) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="13.03"
          y="23.75"
          width=".76"
          height=".76"
          transform="translate(-13.14 16.55) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="15.17"
          y="23.75"
          width=".76"
          height=".76"
          transform="translate(-12.51 18.07) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="16.25"
          y="23.75"
          width=".76"
          height=".76"
          transform="translate(-12.2 18.82) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="17.32"
          y="23.75"
          width=".76"
          height=".76"
          transform="translate(-11.88 19.58) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="18.39"
          y="23.75"
          width=".76"
          height=".76"
          transform="translate(-11.57 20.34) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="20.54"
          y="23.75"
          width=".76"
          height=".76"
          transform="translate(-10.94 21.86) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="23.75"
          y="23.75"
          width=".76"
          height=".76"
          transform="translate(-10 24.13) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="24.83"
          y="23.75"
          width=".76"
          height=".76"
          transform="translate(-9.68 24.89) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="25.9"
          y="23.75"
          width=".76"
          height=".76"
          transform="translate(-9.37 25.65) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="28.04"
          y="23.75"
          width=".76"
          height=".76"
          transform="translate(-8.74 27.16) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="30.19"
          y="23.75"
          width=".76"
          height=".76"
          transform="translate(-8.11 28.68) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="31.26"
          y="23.75"
          width=".76"
          height=".76"
          transform="translate(-7.8 29.44) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="32.33"
          y="23.75"
          width=".76"
          height=".76"
          transform="translate(-7.48 30.2) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="33.41"
          y="23.75"
          width=".76"
          height=".76"
          transform="translate(-7.17 30.96) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="34.48"
          y="23.75"
          width=".76"
          height=".76"
          transform="translate(-6.86 31.71) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="1.23"
          y="24.83"
          width=".76"
          height=".76"
          transform="translate(-17.35 8.52) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="3.38"
          y="24.83"
          width=".76"
          height=".76"
          transform="translate(-16.72 10.04) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="5.52"
          y="24.83"
          width=".76"
          height=".76"
          transform="translate(-16.09 11.55) rotate(-44.99)"
        />
        <rect
          className="cls-1"
          x="7.67"
          y="24.83"
          width=".76"
          height=".76"
          transform="translate(-15.47 13.07) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="8.74"
          y="24.83"
          width=".76"
          height=".76"
          transform="translate(-15.15 13.83) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="11.96"
          y="24.83"
          width=".76"
          height=".76"
          transform="translate(-14.21 16.1) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="13.03"
          y="24.83"
          width=".76"
          height=".76"
          transform="translate(-13.9 16.86) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="14.1"
          y="24.83"
          width=".76"
          height=".76"
          transform="translate(-13.58 17.62) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="17.32"
          y="24.83"
          width=".76"
          height=".76"
          transform="translate(-12.64 19.9) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="18.39"
          y="24.83"
          width=".76"
          height=".76"
          transform="translate(-12.33 20.66) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="20.54"
          y="24.83"
          width=".76"
          height=".76"
          transform="translate(-11.7 22.17) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="21.61"
          y="24.83"
          width=".76"
          height=".76"
          transform="translate(-11.38 22.93) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="26.97"
          y="24.83"
          width=".76"
          height=".76"
          transform="translate(-9.81 26.72) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="29.12"
          y="24.83"
          width=".76"
          height=".76"
          transform="translate(-9.18 28.24) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="34.48"
          y="24.83"
          width=".76"
          height=".76"
          transform="translate(-7.61 32.03) rotate(-45)"
        />
        <rect
          className="cls-1"
          x=".16"
          y="25.9"
          width=".76"
          height=".76"
          transform="translate(-18.42 8.08) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="2.3"
          y="25.9"
          width=".76"
          height=".76"
          transform="translate(-17.8 9.59) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="3.38"
          y="25.9"
          width=".76"
          height=".76"
          transform="translate(-17.48 10.35) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="5.52"
          y="25.9"
          width=".76"
          height=".76"
          transform="translate(-16.85 11.87) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="6.59"
          y="25.9"
          width=".76"
          height=".76"
          transform="translate(-16.54 12.63) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="7.67"
          y="25.9"
          width=".76"
          height=".76"
          transform="translate(-16.23 13.39) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="8.74"
          y="25.9"
          width=".76"
          height=".76"
          transform="translate(-15.91 14.14) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="9.81"
          y="25.9"
          width=".76"
          height=".76"
          transform="translate(-15.6 14.9) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="10.88"
          y="25.9"
          width=".76"
          height=".76"
          transform="translate(-15.28 15.66) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="11.96"
          y="25.9"
          width=".76"
          height=".76"
          transform="translate(-14.97 16.42) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="13.03"
          y="25.9"
          width=".76"
          height=".76"
          transform="translate(-14.65 17.18) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="14.1"
          y="25.9"
          width=".76"
          height=".76"
          transform="translate(-14.34 17.94) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="15.17"
          y="25.9"
          width=".76"
          height=".76"
          transform="translate(-14.03 18.69) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="18.39"
          y="25.9"
          width=".76"
          height=".76"
          transform="translate(-13.08 20.97) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="19.46"
          y="25.9"
          width=".76"
          height=".76"
          transform="translate(-12.77 21.73) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="21.61"
          y="25.9"
          width=".76"
          height=".76"
          transform="translate(-12.14 23.25) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="23.75"
          y="25.9"
          width=".76"
          height=".76"
          transform="translate(-11.51 24.76) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="25.9"
          y="25.9"
          width=".76"
          height=".76"
          transform="translate(-10.88 26.28) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="26.97"
          y="25.9"
          width=".76"
          height=".76"
          transform="translate(-10.57 27.04) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="28.04"
          y="25.9"
          width=".76"
          height=".76"
          transform="translate(-10.26 27.79) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="29.12"
          y="25.9"
          width=".76"
          height=".76"
          transform="translate(-9.94 28.55) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="30.19"
          y="25.9"
          width=".76"
          height=".76"
          transform="translate(-9.63 29.31) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="8.74"
          y="26.97"
          width=".76"
          height=".76"
          transform="translate(-16.67 14.46) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="9.81"
          y="26.97"
          width=".76"
          height=".76"
          transform="translate(-16.36 15.22) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="10.88"
          y="26.97"
          width=".76"
          height=".76"
          transform="translate(-16.04 15.98) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="14.1"
          y="26.97"
          width=".76"
          height=".76"
          transform="translate(-15.1 18.25) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="15.17"
          y="26.97"
          width=".76"
          height=".76"
          transform="translate(-14.78 19.01) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="16.25"
          y="26.97"
          width=".76"
          height=".76"
          transform="translate(-14.47 19.77) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="18.39"
          y="26.97"
          width=".76"
          height=".76"
          transform="translate(-13.84 21.28) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="20.54"
          y="26.97"
          width=".76"
          height=".76"
          transform="translate(-13.21 22.8) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="22.68"
          y="26.97"
          width=".76"
          height=".76"
          transform="translate(-12.59 24.32) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="24.83"
          y="26.97"
          width=".76"
          height=".76"
          transform="translate(-11.96 25.83) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="25.9"
          y="26.97"
          width=".76"
          height=".76"
          transform="translate(-11.64 26.59) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="30.19"
          y="26.97"
          width=".76"
          height=".76"
          transform="translate(-10.39 29.63) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="32.33"
          y="26.97"
          width=".76"
          height=".76"
          transform="translate(-9.76 31.14) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="33.41"
          y="26.97"
          width=".76"
          height=".76"
          transform="translate(-9.44 31.9) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="8.74"
          y="28.04"
          width=".76"
          height=".76"
          transform="translate(-17.43 14.77) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="10.88"
          y="28.04"
          width=".76"
          height=".76"
          transform="translate(-16.8 16.29) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="13.03"
          y="28.04"
          width=".76"
          height=".76"
          transform="translate(-16.17 17.81) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="17.32"
          y="28.04"
          width=".76"
          height=".76"
          transform="translate(-14.91 20.84) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="20.54"
          y="28.04"
          width=".76"
          height=".76"
          transform="translate(-13.97 23.12) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="21.61"
          y="28.04"
          width=".76"
          height=".76"
          transform="translate(-13.66 23.87) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="22.68"
          y="28.04"
          width=".76"
          height=".76"
          transform="translate(-13.34 24.63) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="24.83"
          y="28.04"
          width=".76"
          height=".76"
          transform="translate(-12.72 26.15) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="25.9"
          y="28.04"
          width=".76"
          height=".76"
          transform="translate(-12.4 26.91) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="28.04"
          y="28.04"
          width=".76"
          height=".76"
          transform="translate(-11.77 28.42) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="30.19"
          y="28.04"
          width=".76"
          height=".76"
          transform="translate(-11.14 29.94) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="31.26"
          y="28.04"
          width=".76"
          height=".76"
          transform="translate(-10.83 30.7) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="32.33"
          y="28.04"
          width=".76"
          height=".76"
          transform="translate(-10.52 31.46) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="9.81"
          y="29.12"
          width=".76"
          height=".76"
          transform="translate(-17.87 15.84) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="17.32"
          y="29.12"
          width=".76"
          height=".76"
          transform="translate(-15.67 21.15) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="19.46"
          y="29.12"
          width=".76"
          height=".76"
          transform="translate(-15.04 22.67) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="24.83"
          y="29.12"
          width=".76"
          height=".76"
          transform="translate(-13.47 26.46) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="25.9"
          y="29.12"
          width=".76"
          height=".76"
          transform="translate(-13.16 27.22) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="30.19"
          y="29.12"
          width=".76"
          height=".76"
          transform="translate(-11.9 30.25) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="31.26"
          y="29.12"
          width=".76"
          height=".76"
          transform="translate(-11.59 31.01) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="32.33"
          y="29.12"
          width=".76"
          height=".76"
          transform="translate(-11.28 31.77) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="33.41"
          y="29.12"
          width=".76"
          height=".76"
          transform="translate(-10.96 32.53) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="34.48"
          y="29.12"
          width=".76"
          height=".76"
          transform="translate(-10.65 33.29) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="9.81"
          y="30.19"
          width=".76"
          height=".76"
          transform="translate(-18.63 16.16) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="10.88"
          y="30.19"
          width=".76"
          height=".76"
          transform="translate(-18.32 16.92) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="13.03"
          y="30.19"
          width=".76"
          height=".76"
          transform="translate(-17.69 18.43) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="15.17"
          y="30.19"
          width=".76"
          height=".76"
          transform="translate(-17.06 19.95) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="16.25"
          y="30.19"
          width=".76"
          height=".76"
          transform="translate(-16.75 20.71) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="18.39"
          y="30.19"
          width=".76"
          height=".76"
          transform="translate(-16.12 22.23) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="19.46"
          y="30.19"
          width=".76"
          height=".76"
          transform="translate(-15.8 22.98) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="21.61"
          y="30.19"
          width=".76"
          height=".76"
          transform="translate(-15.17 24.5) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="23.75"
          y="30.19"
          width=".76"
          height=".76"
          transform="translate(-14.55 26.02) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="24.83"
          y="30.19"
          width=".76"
          height=".76"
          transform="translate(-14.23 26.78) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="25.9"
          y="30.19"
          width=".76"
          height=".76"
          transform="translate(-13.92 27.53) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="26.97"
          y="30.19"
          width=".76"
          height=".76"
          transform="translate(-13.6 28.29) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="28.04"
          y="30.19"
          width=".76"
          height=".76"
          transform="translate(-13.29 29.05) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="29.12"
          y="30.19"
          width=".76"
          height=".76"
          transform="translate(-12.98 29.81) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="30.19"
          y="30.19"
          width=".76"
          height=".76"
          transform="translate(-12.66 30.57) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="32.33"
          y="30.19"
          width=".76"
          height=".76"
          transform="translate(-12.03 32.08) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="33.41"
          y="30.19"
          width=".76"
          height=".76"
          transform="translate(-11.72 32.84) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="8.74"
          y="31.26"
          width=".76"
          height=".76"
          transform="translate(-19.7 15.71) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="9.81"
          y="31.26"
          width=".76"
          height=".76"
          transform="translate(-19.39 16.47) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="11.96"
          y="31.26"
          width=".76"
          height=".76"
          transform="translate(-18.76 17.99) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="13.03"
          y="31.26"
          width=".76"
          height=".76"
          transform="translate(-18.45 18.75) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="15.17"
          y="31.26"
          width=".76"
          height=".76"
          transform="translate(-17.82 20.26) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="18.39"
          y="31.26"
          width=".76"
          height=".76"
          transform="translate(-16.88 22.54) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="22.68"
          y="31.26"
          width=".76"
          height=".76"
          transform="translate(-15.62 25.57) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="23.75"
          y="31.26"
          width=".76"
          height=".76"
          transform="translate(-15.31 26.33) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="24.83"
          y="31.26"
          width=".76"
          height=".76"
          transform="translate(-14.99 27.09) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="29.12"
          y="31.26"
          width=".76"
          height=".76"
          transform="translate(-13.73 30.12) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="8.74"
          y="32.33"
          width=".76"
          height=".76"
          transform="translate(-20.46 16.03) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="9.81"
          y="32.33"
          width=".76"
          height=".76"
          transform="translate(-20.15 16.79) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="10.88"
          y="32.33"
          width=".76"
          height=".76"
          transform="translate(-19.83 17.55) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="13.03"
          y="32.33"
          width=".76"
          height=".76"
          transform="translate(-19.2 19.06) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="14.1"
          y="32.33"
          width=".76"
          height=".76"
          transform="translate(-18.89 19.82) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="16.25"
          y="32.33"
          width=".76"
          height=".76"
          transform="translate(-18.26 21.34) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="19.46"
          y="32.33"
          width=".76"
          height=".76"
          transform="translate(-17.32 23.61) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="26.97"
          y="32.33"
          width=".76"
          height=".76"
          transform="translate(-15.12 28.92) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="28.04"
          y="32.33"
          width=".76"
          height=".76"
          transform="translate(-14.81 29.68) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="13.03"
          y="33.41"
          width=".76"
          height=".76"
          transform="translate(-19.96 19.38) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="15.17"
          y="33.41"
          width=".76"
          height=".76"
          transform="translate(-19.34 20.89) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="18.39"
          y="33.41"
          width=".76"
          height=".76"
          transform="translate(-18.39 23.17) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="19.46"
          y="33.41"
          width=".76"
          height=".76"
          transform="translate(-18.08 23.93) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="20.54"
          y="33.41"
          width=".76"
          height=".76"
          transform="translate(-17.76 24.69) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="21.61"
          y="33.41"
          width=".76"
          height=".76"
          transform="translate(-17.45 25.44) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="22.68"
          y="33.41"
          width=".76"
          height=".76"
          transform="translate(-17.14 26.2) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="25.9"
          y="33.41"
          width=".76"
          height=".76"
          transform="translate(-16.19 28.48) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="28.04"
          y="33.41"
          width=".76"
          height=".76"
          transform="translate(-15.57 29.99) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="34.48"
          y="33.41"
          width=".76"
          height=".76"
          transform="translate(-13.68 34.54) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="10.88"
          y="34.48"
          width=".76"
          height=".76"
          transform="translate(-21.35 18.17) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="11.96"
          y="34.48"
          width=".76"
          height=".76"
          transform="translate(-21.04 18.93) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="14.1"
          y="34.48"
          width=".76"
          height=".76"
          transform="translate(-20.41 20.45) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="16.25"
          y="34.48"
          width=".76"
          height=".76"
          transform="translate(-19.78 21.97) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="21.61"
          y="34.48"
          width=".76"
          height=".76"
          transform="translate(-18.21 25.76) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="24.83"
          y="34.48"
          width=".76"
          height=".76"
          transform="translate(-17.27 28.03) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="29.12"
          y="34.48"
          width=".76"
          height=".76"
          transform="translate(-16.01 31.07) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="30.19"
          y="34.48"
          width=".76"
          height=".76"
          transform="translate(-15.7 31.82) rotate(-45)"
        />
        <rect
          className="cls-1"
          x="32.33"
          y="34.48"
          width=".76"
          height=".76"
          transform="translate(-15.07 33.34) rotate(-45)"
        />
        <path className="cls-1" d="m6.38,0H0v7.51h7.51V0h-1.13Zm0,6.38H1.13V1.13h5.26v5.26Z" />
        <path
          className="cls-1"
          d="m34.27,0h-6.38v7.51h7.51V0h-1.13Zm0,6.38h-5.26V1.13h5.26v5.26Z"
        />
        <path
          className="cls-1"
          d="m6.38,27.89H0v7.51h7.51v-7.51h-1.13Zm0,6.38H1.13v-5.26h5.26v5.26Z"
        />
        <path
          className="cls-1"
          d="m2.15,5.36c.19-1.07.19-2.15,0-3.22.54.1,1.07.14,1.61.14s1.07-.05,1.61-.14c-.19,1.07-.19,2.15,0,3.22-.54-.1-1.08-.14-1.61-.14s-1.07.05-1.61.14"
        />
        <path
          className="cls-1"
          d="m30.03,5.36c.19-1.07.19-2.15,0-3.22.54.1,1.08.14,1.61.14s1.07-.05,1.61-.14c-.19,1.07-.19,2.15,0,3.22-.54-.1-1.08-.14-1.61-.14s-1.07.05-1.61.14"
        />
        <path
          className="cls-1"
          d="m2.15,33.25c.19-1.07.19-2.15,0-3.22.54.1,1.07.14,1.61.14s1.07-.05,1.61-.14c-.19,1.07-.19,2.15,0,3.22-.54-.09-1.08-.14-1.61-.14s-1.07.05-1.61.14"
        />
        <rect fill="#fff" x="11.8" y="11.8" width="11.8" height="11.8" />
        <path d="m19.85,18.24h0c-.04-.1-.1-.19-.17-.27l-.02-.02h0s.5-1.37.5-1.37l.6,1.66h-.9Zm-1.84-.62v-1.69h.39c.52,0,.79.31.79.89,0,.62-.16.81-.67.81h-.51Zm-2.52.62l.6-1.67.6,1.67h-1.21Zm6.33,1.24l-1.4-3.68h0s-.02,0-.02,0l-.77,2.13c-.17-.16-.42-.25-.73-.29h-.1s.09-.02.09-.02c.51-.09.86-.42.86-.81,0-.54-.5-.91-1.22-.91h-1.52v.03h.44v2.72l-1.08-2.85h-.02l-1.33,3.68h0s-.13,0-.13,0h-1.08l2.11-3.59h-2.55v1.1h.03c0-.54.32-1.07,1.01-1.07h.87l-2.11,3.59h2.79v-1.05h-.03c0,.47-.27.91-.84,1.01h-.02s.44-1.2.44-1.2h1.23l.44,1.22h-.43v.03h1.73v-.03h-.44v-1.84h.51c.51,0,.81.23.81.63v.46s-.27.75-.27.75h-.36v.03h.74v-.03h-.35l.25-.68h0s0,.07,0,.07v.04c.05.25.14.44.29.55h.02c.11.09.25.13.42.13.22,0,.36-.05.48-.18l-.02-.02c-.11.1-.2.14-.32.14-.2,0-.3-.24-.3-.47v-.46c0-.12-.02-.23-.05-.33h0s.9-.01.9-.01l.44,1.22h-.43v.03h1.48v-.03h-.43Z" />
      </g>
    </svg>
  )
}

export const LeatherIcon = ({ className }) => {
  return (
    <svg className={className} viewBox="0 0 141.73 141.73" fill="currentColor">
      <path
        d="M69.72,64.9c0.35-0.39,0.69-0.88,1.01-1.48h0.63c0.69,1.27,1.48,1.91,237,1.91c0.46,0,0.93-0.17,1.42-0.52l0.93,1.12
    c-1.28,1.33-1.92,2.82-1.92,4.48c0,1.75,0.8,3.54,2.41,5.36c0,0.04-0.4,0.45-1.2,1.26h-0.03c-0.52-1.08-1.34-1.62-2.46-1.62
    c-0.64,0-1.22,0.43-1.75,1.28c-0.6-0.74-1.22-1.12-1.86-1.12c-0.77,0-1.55,055-2.35,1.64v0.03c-0.06,0-0.74-0.5-2.03-1.5
    c1.79-2.03,2.68-4.03,2.68-5.99v-0.11c0-1.46-0.57-2.86-1.7-4.18l1.15-0.96c0.5,0.59,1.01,0.88,1.53,0.88
    C68.95,65.39,69.33,65.23,69.72,64.9z M70.46,63.01c-0.62,1.33-1.25,2-1.89,2c-0.45,0-0.93-0.35-1.45-1.06h-0.03l-1.78,1.45v0.05
    c1.26,1.35,1.89,2.78,1.89,4.29c0,0.93-0.26,1.98-0.79,3.15c-0.47,0.97-1.17,1.93-2.11,2.9v0.03l2.65,2.02h0.03l0.03-0.03
    c0.84-1.2,1.57-1.8,2.19-1.8h0.16c0.36,0,0.77,0.23,1.23,0.68c0.26,0.4,0.45,0.61,0.55,0.61c0.14,0,0.24-0.11,0.3-0.33
    c0.5-0.74,0.95-1.12,1.34-1.12h0.14c1.12,0,1.89,0.65,2.29,1.94l1.94-2c-1.71-1.83-2.57-3.57-2.57-5.19v-0.36
    c0-1.49,0.68-2.91,2.05-4.26v-0.03l-1.45-1.67c-0.56,0.46-1.04,0.69-1.45,0.69c-0.49,0-0.99-0.3-1.5-0.91l-0.62-1.04H70.46z"
      />
    </svg>
  )
}
